// React
import React, { useState } from 'react'

import { useNavigate } from 'react-router-dom'

// Appt
import Anchor from '../../simple/anchor/Anchor.js'
import Box from '../../simple/box/Box.js'
import Button from '../../simple/button/Button.js'
import Form from '../../simple/form/Form.js'
import FormField from '../../simple/formField/FormField.js'
import Text from '../../simple/text/Text.js'
import TextInput from '../../simple/input/TextInput.js'

/**
 * `UserVerification` renders a UserVerification screen
 */
function UserVerification (props) {
  const navigate = useNavigate()

  const [code, setCode] = useState({
    verificationCode: ''
  })

  const handleBackClick = () => navigate('/login')

  const handleCodeChange = (code) => {
    setCode(code)
  }

  const onSubmit = () => {
    // if (code.verificationCode.length !== 5) {
    //   NotificationService.error('Code must be five characters')
    // } else {
    props.handleVerificationCode(code.verificationCode)
    // }
  }

  return (
    <>
      <Box align='center' animation='fadeIn' alignSelf='center' width='medium'>
        <Box width='medium'>
          <Text color={props.labelColor} margin={{ top: 'medium', bottom: 'medium' }} textAlign='start' weight='bold' size='26px'>Login Verification</Text>
        </Box>

        <Box width='medium'>
          <Form
            onChange={nextValue => {
              handleCodeChange(nextValue)
            }}
            onSubmit={() => onSubmit()}
            value={code}
          >
            <Text color='white' size='small'>Your email address needs to be verified before you can login. Please check your email for a verification code and enter it below.</Text>

            <FormField margin={{ vertical: 'small' }} name='verificationCode' required>
              <TextInput name='verificationCode' placeholder='Enter verification code' />
            </FormField>

            <Button fill='horizontal' label='Verify' primary type='submit' />

            <Box direction='row' justify='between' margin={{ top: 'medium' }}>
              <Anchor color='white' onClick={() => handleBackClick()} size='xsmall' label='< Back to login' />
            </Box>
          </Form>
        </Box>
      </Box>
    </>)
}

export default UserVerification
